import type { IconData } from '@stacksjs/iconify-core'

export const filter: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M238.627 496H192V253.828l-168-200V16h456v37.612l-160 200v161.015ZM224 464h1.373L288 401.373V242.388L443.51 48H60.9L224 242.172Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default filter
